export default __webpack_public_path__ + "static/media/Averta-Regular.b205e641.ttf";